// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroThumbnailStack-cls1_HtG","cls2":"HeroThumbnailStack-cls2_z0L HeroThumbnailStack-cls1_HtG"};